const isEmailValid = (email = '') => (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/.test(email))

export default isEmailValid